import { render } from "./FAQGroup.vue?vue&type=template&id=5ed14e73"
import script from "./FAQGroup.vue?vue&type=script&lang=js"
export * from "./FAQGroup.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./FAQGroup.vue?vue&type=style&index=0&id=5ed14e73&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script